//LIST_EVENT_TYPE = ["sports", "announcements", "news", "meetings", "workshops", "webinars", "conferences", "seminars", "hackathons", "others"] as const,
export const EVENT_RAW_TYPES = {
    sports: {
        label: 'Sport',
        categories: [
            {
                label: 'Soccer',
                value: 'soccer'
            },
            {
                label: 'Basketball',
                value: 'basketball'
            },
            {
                label: 'Boxing',
                value: 'boxing'
            },
            {
                label: 'Table tennis',
                value: 'tabletennis'
            },
            {
                label: 'Tennis',
                value: 'tennis'
            },
            {
                label: 'Ice hockey',
                value: 'icehockey'
            },
            {
                label: 'Hockey',
                value: 'hockey'
            },
            {
                label: 'Golf',
                value: 'golf'
            },
            {
                label: 'Volleyball',
                value: 'volleyball'
            },
            {
                label: 'Baseball',
                value: 'baseball'
            },
            {
                label: 'Rugby',
                value: 'rugby'
            },
        ]
    },
    eSports: {
        label: 'eSport',
        categories: [
            {
                label: 'MOBA (e.g. League of Legends, Dota 2)',
                value: 'moba'
            },
            {
                label: 'FPS Tactical (e.g. CS:GO, Valorant)',
                value: 'fps_tactical'
            },
            {
                label: 'FPS Battle Royale (e.g. Warzone, Apex)',
                value: 'fps_battleroyale'
            },
            {
                label: 'Hero Shooter (e.g. Overwatch)',
                value: 'hero_shooter'
            },
            {
                label: 'RTS (e.g. StarCraft II, Age of Empires)',
                value: 'rts'
            },
            {
                label: 'Fighting (e.g. Street Fighter, Smash Bros.)',
                value: 'fighting'
            },
            {
                label: 'Racing (e.g. iRacing, F1)',
                value: 'racing'
            },
            {
                label: 'Sports Simulation (e.g. EA FC, NBA 2K)',
                value: 'sports_simulation'
            },
            {
                label: 'Card Games (e.g. Hearthstone)',
                value: 'card_games'
            },
            {
                label: 'Auto Battler (e.g. Teamfight Tactics)',
                value: 'auto_battler'
            },
            {
                label: 'Vehicle Arena (e.g. Rocket League)',
                value: 'vehicle_arena'
            }
        ]
    },
    news: {
        label: 'News',
        categories: [
            {
                label: 'Rails',
                value: 'rails'
            },
            {
                label: 'Sinatra',
                value: 'sinatra'
            }
        ]
    },
    other: {
        label: 'Other',
        categories: [
            {
                label: 'Laravel',
                value: 'laravel'
            },
            {
                label: 'Phoenix',
                value: 'phoenix'
            }
        ]
    }
} as const;

function transformEventTypes(rawTypes: typeof EVENT_RAW_TYPES) {
    return Object.entries(rawTypes).map(([typeKey, typeValue]) => ({
        mainType: typeValue.label,
        categories: typeValue.categories.map(category => ({
            subType: category.value,
            type: typeKey
        }))
    }));
}

const EVENT_TYPES2: {
    mainType: string,
    categories: {
        subType: string;
        type: string;
    }[]
}[] = [

] as const;

// Dynamic generation + manual type assertion

const EVENT_TYPES = transformEventTypes(EVENT_RAW_TYPES) as unknown as readonly {
    mainType: string;
    categories: readonly {
        subType: string;
        type: string;
    }[];
}[];


export default EVENT_TYPES;
